import React from 'react';

import UserPage from "./UserPage";

interface UserPageProps {}

const UserPageContainer: React.FC<UserPageProps> = () => {
  return <UserPage />
}

export default UserPageContainer;